import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { CompanyWidget } from '@/widgets/company-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.names': z.array(z.string()).optional(),
  'filter.bins': z.array(z.string()).optional(),
  'filter.codes': z.array(z.string()).optional(),
  'filter.katoIds': z.array(z.string()).optional(),
  'filter.active': z.boolean().optional(),
})

export const Route = createFileRoute('/_auth/administration/reference-books/company')({
  staticData: {
    meta: {
      title: 'Организации',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.COMPANIES}>
      <PageWrapper title={t('Организации')}>
        <CompanyWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
